import React from "react";
import { useLocation } from "react-router-dom";

import PageError from "../../components/Error/PageError";

const LtiError = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const errorTitle = searchParams.get("title") || "LTI error encountered";
  const errorMessage = searchParams.get("message") || "An unknown error has been encountered while processing the LTI request.";

  return (
    <PageError error={true} title={errorTitle} errorMessage={errorMessage} />
  );
};

export default LtiError;
